// extracted by mini-css-extract-plugin
export default {"resetButton":"HZms5sC","docType":"_xcQJc7"};